export default __webpack_public_path__ + "static/media/Illustration.25158f3c.png";